import axios from 'axios';
import { i18n } from '@/main';
import config from '@/helpers/config';

interface JsReportRequest {
    template: { name: string };
    data: any;
    options: any;
}
const configuration = config();
const { JSREPORT_API, REPORT_AUTH } = configuration;
const reportAuth = `Basic ${btoa(REPORT_AUTH)}`;

const removeZumo = () => {
    delete axios.defaults.headers.common['X-ZUMO-AUTH'];
};

const language = () => {
    const localLang = JSON.parse(localStorage.getItem('isLoggedin')!);
    const lang = localLang.user.language;
    if (i18n.locale) {
        return i18n.locale;
    }
    if (lang) {
        return lang;
    }
    return 'en';
};

const downloadDocument = async (templateName: string, reportName: string, data: any, lang?: string): Promise<any> => {
    try {
        const requestData: JsReportRequest = {
            template: { name: templateName },
            data,
            options: { language: lang || language() },
        };

        removeZumo();
        const res = await axios.post(`${JSREPORT_API}/api/report`, requestData, {
            headers: { Authorization: reportAuth },
            responseType: 'blob',
        });

        const newBlob = new Blob([res.data], { type: 'application/pdf' });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
        }

        const urlData = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = urlData;
        link.download = reportName;
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

        setTimeout(() => {
            window.URL.revokeObjectURL(urlData);
            link.remove();
        }, 100);
    } catch (err) {
        console.log(err);
    }
};


export default {
    downloadDocument,
};
